module.exports = function ($)
{
	return {
		init: function ()
		{
			var $searchFilters = $('.resourceSearch__filter'),
				$searchFilterClose = $searchFilters.find('a.small-close'),
				$smallScreenFilterToggle = $('.resourceSearch__filterToggle').find('a'),
				$collectButton = $('.resourceSearch__results__list__collect').find('a'),
				$filterActiveStateTarget = $('body');

			// result collect button widget
			$collectButton.click(function($event)
			{
				$event.preventDefault();
				$(this).parent().toggleClass('active');
			});

			// small screen device filter toggle
			$smallScreenFilterToggle.on('click touch', function($event)
			{
				$event.preventDefault();
				$filterActiveStateTarget.addClass('search-filters-active');
				$('html, body').animate({
					scrollTop: 0
				},500);
			});

			$searchFilterClose.on('click touch', function($event)
			{
				$event.preventDefault();
				$filterActiveStateTarget.removeClass('search-filters-active');
			});
		}
	}
};